module.exports = __webpack_public_path__ + "img/arrowtop.4b4a49e9.svg";